const Toggle = props => {
  const toggleClick = () => {
    props.PostSettingChange('toggle', !props.active);
  }
  return (
    <div className="modal fade" id="toggle" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="toggle" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">{props.active?"Wechsel-Sound deaktivieren":"Wechsel-Sound aktivieren"}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
        {props.active?
            <>
              <p>Mit der Abschaltung der Funktion «Wechsel-Sound» werden die Tracks wieder „normal“ durchnummeriert.</p>
              <p>Wird der Wechsel-Sound deaktiviert, müssen die Soundsticker neu gedruckt und der Hörstift synchronisiert werden.</p>
            </>
        :   
            <>
              <p>Mit der Funktion «Wechsel-Sound» werden beim mehrmaligen Antippen des Soundstickers zwei unterschiedliche Tracks abgespielt. Dazu werden im Creator die Tracks neu nummeriert: Track 1 und Track 2 werden zu Track 1a und Track 1b.</p>
              <p>Die Soundsticker müssen bei aktiviertem Wechsel-Sound neu gedruckt und der Hörstift synchronisiert werden. Der Wechsel-Sound kann wieder deaktiviert werden, ohne dass sich die Tracks ändern.</p>
            </>
        }
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={toggleClick}>{props.active?"Wechsel-Sound deaktivieren":"Wechsel-Sound aktivieren"}</button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Toggle;